import React from "react";
import "./contact.css";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaFacebookF,
  FaTelegram,
  FaLinkedinIn,
  FaWhatsapp,
} from "react-icons/fa";

export default function Contact() {
  return (
    <section className="contact-section" id="contact">
      <h2>Contact Me</h2>

      <div className="contact-cards">
        <a href="mailto:emil.rishko@gmail.com" className="contact-card">
          <FaEnvelope className="card-icon" />
          <div>
            <p>emil.rishko@gmail.com</p>
          </div>
        </a>

        <a href="tel:+36301783757" className="contact-card">
          <FaPhoneAlt className="card-icon" />
          <div>
            <p>+36 30 178 3757</p>
          </div>
        </a>

        <div className="contact-card">
          <FaMapMarkerAlt className="card-icon" />
          <div>
            <p>Budapest, Hungary</p>
          </div>
        </div>
      </div>

      <div className="social-icons">
        <a href="https://www.facebook.com/profile.php?id=100004117207787" target="_blank" rel="noreferrer"><FaFacebookF /></a>
        <a href="https://www.linkedin.com/in/emil-risko-02ab012a0" target="_blank" rel="noreferrer"><FaLinkedinIn /></a>
        <a href="https://wa.me/+36301783757"><FaWhatsapp /></a>
        <a href="https://t.me/emilrisko"><FaTelegram /></a>
      </div>

         <p className="copyright">
        © {new Date().getFullYear()} Emil Risko. All rights reserved.
      </p>
    </section>
  );
}
